import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';

const withDocumentTitle = (Component) => (props) => {
  useEffect(() => {
    document.title = `Suppliers${!isEmpty(props.documentTitle) ? ` - ${props.documentTitle}` : ''}`;
  }, [props.documentTitle]);

  return <Component {...props} />;
};

export default withDocumentTitle;
